import './widgets.css'
import React from 'react'
import keys from 'constants/keys'
import { Content, Subtask } from '../../model/types'
import DescriptionWidget from '../../Steps/SubtaskCreationStep/Widgets/Description'
import ImageWidget from '../../Steps/SubtaskCreationStep/Widgets/Image'
import VideoWidget from '../../Steps/SubtaskCreationStep/Widgets/Video'
import PollWidget from '../../Steps/SubtaskCreationStep/Widgets/Poll'
import LinkWidget from '../../Steps/SubtaskCreationStep/Widgets/Link'
import OpenQuestionWidget from '../../Steps/SubtaskCreationStep/Widgets/OpenQuestion'

/** Uses the existing field registration, validation, uploads and AI workflow unchanged. */
export function SubtaskEditor({
  field,
  index,
  remove,
}: {
  field: Subtask | Content
  index: number
  remove: () => void
}) {
  const props = { index, subtaskPath: `sub_tasks[${index}]`, isDragging: false, remove }

  switch (field.type) {
    case keys.SUBTASK_TYPES.DESCRIPTION:
      return <DescriptionWidget {...props} field={field as Content} />
    case keys.SUBTASK_TYPES.IMAGE_SUBTASK:
      return <ImageWidget {...props} field={field as Subtask} />
    case keys.SUBTASK_TYPES.VIDEO_SUBTASKS:
      return <VideoWidget {...props} field={field as Subtask} />
    case keys.SUBTASK_TYPES.POLL_SUBTASK:
    case keys.SUBTASK_TYPES.PRIVATE_POLL:
      return <PollWidget {...props} field={field as Subtask} />
    case keys.SUBTASK_TYPES.LINK_SUBTASK:
      return <LinkWidget {...props} field={field as Subtask} />
    case keys.SUBTASK_TYPES.OPEN_QUESTION:
      return <OpenQuestionWidget {...props} field={field as Subtask} />
    default:
      return null
  }
}
